module.exports = __webpack_public_path__ + "img/proiecte.e6990732.svg";